import CollapseButtonGroup from './src'

CollapseButtonGroup.install = Vue => {
  Vue.component(CollapseButtonGroup.name, CollapseButtonGroup)
}

export default CollapseButtonGroup
